/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as dashboardAuthenticatedRouteImport } from './routes/(dashboard)/_authenticated'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authCodeRouteImport } from './routes/(auth)/code'
import { Route as dashboardAuthenticatedIndexRouteImport } from './routes/(dashboard)/_authenticated/index'
import { Route as dashboardAuthenticatedCompanyIdRouteRouteImport } from './routes/(dashboard)/_authenticated/$companyId/route'
import { Route as dashboardInvitationInvitationCodeIndexRouteImport } from './routes/(dashboard)/invitation/$invitationCode/index'
import { Route as dashboardAuthenticatedCompanyIdIndexRouteImport } from './routes/(dashboard)/_authenticated/$companyId/index'
import { Route as dashboardAuthenticatedAdminGuardRouteImport } from './routes/(dashboard)/_authenticated/admin/_guard'
import { Route as dashboardAuthenticatedCompanyIdSettingsRouteImport } from './routes/(dashboard)/_authenticated/$companyId/settings'
import { Route as dashboardAuthenticatedCompanyIdMyMailboxRouteImport } from './routes/(dashboard)/_authenticated/$companyId/my-mailbox'
import { Route as dashboardAuthenticatedCompanyIdMailboxRouteImport } from './routes/(dashboard)/_authenticated/$companyId/mailbox'
import { Route as dashboardAuthenticatedCompanyIdFormsRouteImport } from './routes/(dashboard)/_authenticated/$companyId/forms'
import { Route as dashboardAuthenticatedCompanyIdActionsRouteImport } from './routes/(dashboard)/_authenticated/$companyId/actions'
import { Route as dashboardAuthenticatedAdminGuardIndexRouteImport } from './routes/(dashboard)/_authenticated/admin/_guard/index'
import { Route as dashboardAuthenticatedAdminGuardUsersRouteImport } from './routes/(dashboard)/_authenticated/admin/_guard/users'
import { Route as dashboardAuthenticatedAdminGuardCompaniesRouteImport } from './routes/(dashboard)/_authenticated/admin/_guard/companies'
import { Route as dashboardAuthenticatedCompanyIdTeamTeamIdIndexRouteImport } from './routes/(dashboard)/_authenticated/$companyId/team/$teamId/index'
import { Route as dashboardAuthenticatedCompanyIdFFormIdIndexRouteImport } from './routes/(dashboard)/_authenticated/$companyId/f/$formId/index'
import { Route as dashboardAuthenticatedCompanyIdTeamTeamIdFormsRouteImport } from './routes/(dashboard)/_authenticated/$companyId/team/$teamId/forms'
import { Route as dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRouteImport } from './routes/(dashboard)/_authenticated/$companyId/team/$teamId/dashboard'
import { Route as dashboardAuthenticatedCompanyIdTeamTeamIdActionsRouteImport } from './routes/(dashboard)/_authenticated/$companyId/team/$teamId/actions'
import { Route as dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRouteImport } from './routes/(dashboard)/_authenticated/$companyId/team/$teamId/f/$formId/index'

const dashboardRouteImport = createFileRoute('/(dashboard)')()
const dashboardAuthenticatedAdminRouteImport = createFileRoute(
  '/(dashboard)/_authenticated/admin',
)()

const dashboardRoute = dashboardRouteImport.update({
  id: '/(dashboard)',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardAuthenticatedRoute = dashboardAuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => dashboardRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authCodeRoute = authCodeRouteImport.update({
  id: '/(auth)/code',
  path: '/code',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardAuthenticatedAdminRoute =
  dashboardAuthenticatedAdminRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => dashboardAuthenticatedRoute,
  } as any)
const dashboardAuthenticatedIndexRoute =
  dashboardAuthenticatedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardAuthenticatedRoute,
  } as any)
const dashboardAuthenticatedCompanyIdRouteRoute =
  dashboardAuthenticatedCompanyIdRouteRouteImport.update({
    id: '/$companyId',
    path: '/$companyId',
    getParentRoute: () => dashboardAuthenticatedRoute,
  } as any)
const dashboardInvitationInvitationCodeIndexRoute =
  dashboardInvitationInvitationCodeIndexRouteImport.update({
    id: '/invitation/$invitationCode/',
    path: '/invitation/$invitationCode/',
    getParentRoute: () => dashboardRoute,
  } as any)
const dashboardAuthenticatedCompanyIdIndexRoute =
  dashboardAuthenticatedCompanyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedAdminGuardRoute =
  dashboardAuthenticatedAdminGuardRouteImport.update({
    id: '/_guard',
    getParentRoute: () => dashboardAuthenticatedAdminRoute,
  } as any)
const dashboardAuthenticatedCompanyIdSettingsRoute =
  dashboardAuthenticatedCompanyIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedCompanyIdMyMailboxRoute =
  dashboardAuthenticatedCompanyIdMyMailboxRouteImport.update({
    id: '/my-mailbox',
    path: '/my-mailbox',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedCompanyIdMailboxRoute =
  dashboardAuthenticatedCompanyIdMailboxRouteImport.update({
    id: '/mailbox',
    path: '/mailbox',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedCompanyIdFormsRoute =
  dashboardAuthenticatedCompanyIdFormsRouteImport.update({
    id: '/forms',
    path: '/forms',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedCompanyIdActionsRoute =
  dashboardAuthenticatedCompanyIdActionsRouteImport.update({
    id: '/actions',
    path: '/actions',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedAdminGuardIndexRoute =
  dashboardAuthenticatedAdminGuardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardAuthenticatedAdminGuardRoute,
  } as any)
const dashboardAuthenticatedAdminGuardUsersRoute =
  dashboardAuthenticatedAdminGuardUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => dashboardAuthenticatedAdminGuardRoute,
  } as any)
const dashboardAuthenticatedAdminGuardCompaniesRoute =
  dashboardAuthenticatedAdminGuardCompaniesRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => dashboardAuthenticatedAdminGuardRoute,
  } as any)
const dashboardAuthenticatedCompanyIdTeamTeamIdIndexRoute =
  dashboardAuthenticatedCompanyIdTeamTeamIdIndexRouteImport.update({
    id: '/team/$teamId/',
    path: '/team/$teamId/',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedCompanyIdFFormIdIndexRoute =
  dashboardAuthenticatedCompanyIdFFormIdIndexRouteImport.update({
    id: '/f/$formId/',
    path: '/f/$formId/',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedCompanyIdTeamTeamIdFormsRoute =
  dashboardAuthenticatedCompanyIdTeamTeamIdFormsRouteImport.update({
    id: '/team/$teamId/forms',
    path: '/team/$teamId/forms',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRoute =
  dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRouteImport.update({
    id: '/team/$teamId/dashboard',
    path: '/team/$teamId/dashboard',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedCompanyIdTeamTeamIdActionsRoute =
  dashboardAuthenticatedCompanyIdTeamTeamIdActionsRouteImport.update({
    id: '/team/$teamId/actions',
    path: '/team/$teamId/actions',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)
const dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRoute =
  dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRouteImport.update({
    id: '/team/$teamId/f/$formId/',
    path: '/team/$teamId/f/$formId/',
    getParentRoute: () => dashboardAuthenticatedCompanyIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/code': typeof authCodeRoute
  '/login': typeof authLoginRoute
  '/': typeof dashboardAuthenticatedIndexRoute
  '/$companyId': typeof dashboardAuthenticatedCompanyIdRouteRouteWithChildren
  '/$companyId/actions': typeof dashboardAuthenticatedCompanyIdActionsRoute
  '/$companyId/forms': typeof dashboardAuthenticatedCompanyIdFormsRoute
  '/$companyId/mailbox': typeof dashboardAuthenticatedCompanyIdMailboxRoute
  '/$companyId/my-mailbox': typeof dashboardAuthenticatedCompanyIdMyMailboxRoute
  '/$companyId/settings': typeof dashboardAuthenticatedCompanyIdSettingsRoute
  '/admin': typeof dashboardAuthenticatedAdminGuardRouteWithChildren
  '/$companyId/': typeof dashboardAuthenticatedCompanyIdIndexRoute
  '/invitation/$invitationCode': typeof dashboardInvitationInvitationCodeIndexRoute
  '/admin/companies': typeof dashboardAuthenticatedAdminGuardCompaniesRoute
  '/admin/users': typeof dashboardAuthenticatedAdminGuardUsersRoute
  '/admin/': typeof dashboardAuthenticatedAdminGuardIndexRoute
  '/$companyId/team/$teamId/actions': typeof dashboardAuthenticatedCompanyIdTeamTeamIdActionsRoute
  '/$companyId/team/$teamId/dashboard': typeof dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRoute
  '/$companyId/team/$teamId/forms': typeof dashboardAuthenticatedCompanyIdTeamTeamIdFormsRoute
  '/$companyId/f/$formId': typeof dashboardAuthenticatedCompanyIdFFormIdIndexRoute
  '/$companyId/team/$teamId': typeof dashboardAuthenticatedCompanyIdTeamTeamIdIndexRoute
  '/$companyId/team/$teamId/f/$formId': typeof dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRoute
}
export interface FileRoutesByTo {
  '/code': typeof authCodeRoute
  '/login': typeof authLoginRoute
  '/': typeof dashboardAuthenticatedIndexRoute
  '/$companyId/actions': typeof dashboardAuthenticatedCompanyIdActionsRoute
  '/$companyId/forms': typeof dashboardAuthenticatedCompanyIdFormsRoute
  '/$companyId/mailbox': typeof dashboardAuthenticatedCompanyIdMailboxRoute
  '/$companyId/my-mailbox': typeof dashboardAuthenticatedCompanyIdMyMailboxRoute
  '/$companyId/settings': typeof dashboardAuthenticatedCompanyIdSettingsRoute
  '/admin': typeof dashboardAuthenticatedAdminGuardIndexRoute
  '/$companyId': typeof dashboardAuthenticatedCompanyIdIndexRoute
  '/invitation/$invitationCode': typeof dashboardInvitationInvitationCodeIndexRoute
  '/admin/companies': typeof dashboardAuthenticatedAdminGuardCompaniesRoute
  '/admin/users': typeof dashboardAuthenticatedAdminGuardUsersRoute
  '/$companyId/team/$teamId/actions': typeof dashboardAuthenticatedCompanyIdTeamTeamIdActionsRoute
  '/$companyId/team/$teamId/dashboard': typeof dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRoute
  '/$companyId/team/$teamId/forms': typeof dashboardAuthenticatedCompanyIdTeamTeamIdFormsRoute
  '/$companyId/f/$formId': typeof dashboardAuthenticatedCompanyIdFFormIdIndexRoute
  '/$companyId/team/$teamId': typeof dashboardAuthenticatedCompanyIdTeamTeamIdIndexRoute
  '/$companyId/team/$teamId/f/$formId': typeof dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)/code': typeof authCodeRoute
  '/(auth)/login': typeof authLoginRoute
  '/(dashboard)': typeof dashboardRouteWithChildren
  '/(dashboard)/_authenticated': typeof dashboardAuthenticatedRouteWithChildren
  '/(dashboard)/_authenticated/$companyId': typeof dashboardAuthenticatedCompanyIdRouteRouteWithChildren
  '/(dashboard)/_authenticated/': typeof dashboardAuthenticatedIndexRoute
  '/(dashboard)/_authenticated/$companyId/actions': typeof dashboardAuthenticatedCompanyIdActionsRoute
  '/(dashboard)/_authenticated/$companyId/forms': typeof dashboardAuthenticatedCompanyIdFormsRoute
  '/(dashboard)/_authenticated/$companyId/mailbox': typeof dashboardAuthenticatedCompanyIdMailboxRoute
  '/(dashboard)/_authenticated/$companyId/my-mailbox': typeof dashboardAuthenticatedCompanyIdMyMailboxRoute
  '/(dashboard)/_authenticated/$companyId/settings': typeof dashboardAuthenticatedCompanyIdSettingsRoute
  '/(dashboard)/_authenticated/admin': typeof dashboardAuthenticatedAdminRouteWithChildren
  '/(dashboard)/_authenticated/admin/_guard': typeof dashboardAuthenticatedAdminGuardRouteWithChildren
  '/(dashboard)/_authenticated/$companyId/': typeof dashboardAuthenticatedCompanyIdIndexRoute
  '/(dashboard)/invitation/$invitationCode/': typeof dashboardInvitationInvitationCodeIndexRoute
  '/(dashboard)/_authenticated/admin/_guard/companies': typeof dashboardAuthenticatedAdminGuardCompaniesRoute
  '/(dashboard)/_authenticated/admin/_guard/users': typeof dashboardAuthenticatedAdminGuardUsersRoute
  '/(dashboard)/_authenticated/admin/_guard/': typeof dashboardAuthenticatedAdminGuardIndexRoute
  '/(dashboard)/_authenticated/$companyId/team/$teamId/actions': typeof dashboardAuthenticatedCompanyIdTeamTeamIdActionsRoute
  '/(dashboard)/_authenticated/$companyId/team/$teamId/dashboard': typeof dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRoute
  '/(dashboard)/_authenticated/$companyId/team/$teamId/forms': typeof dashboardAuthenticatedCompanyIdTeamTeamIdFormsRoute
  '/(dashboard)/_authenticated/$companyId/f/$formId/': typeof dashboardAuthenticatedCompanyIdFFormIdIndexRoute
  '/(dashboard)/_authenticated/$companyId/team/$teamId/': typeof dashboardAuthenticatedCompanyIdTeamTeamIdIndexRoute
  '/(dashboard)/_authenticated/$companyId/team/$teamId/f/$formId/': typeof dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/code'
    | '/login'
    | '/'
    | '/$companyId'
    | '/$companyId/actions'
    | '/$companyId/forms'
    | '/$companyId/mailbox'
    | '/$companyId/my-mailbox'
    | '/$companyId/settings'
    | '/admin'
    | '/$companyId/'
    | '/invitation/$invitationCode'
    | '/admin/companies'
    | '/admin/users'
    | '/admin/'
    | '/$companyId/team/$teamId/actions'
    | '/$companyId/team/$teamId/dashboard'
    | '/$companyId/team/$teamId/forms'
    | '/$companyId/f/$formId'
    | '/$companyId/team/$teamId'
    | '/$companyId/team/$teamId/f/$formId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/code'
    | '/login'
    | '/'
    | '/$companyId/actions'
    | '/$companyId/forms'
    | '/$companyId/mailbox'
    | '/$companyId/my-mailbox'
    | '/$companyId/settings'
    | '/admin'
    | '/$companyId'
    | '/invitation/$invitationCode'
    | '/admin/companies'
    | '/admin/users'
    | '/$companyId/team/$teamId/actions'
    | '/$companyId/team/$teamId/dashboard'
    | '/$companyId/team/$teamId/forms'
    | '/$companyId/f/$formId'
    | '/$companyId/team/$teamId'
    | '/$companyId/team/$teamId/f/$formId'
  id:
    | '__root__'
    | '/(auth)/code'
    | '/(auth)/login'
    | '/(dashboard)'
    | '/(dashboard)/_authenticated'
    | '/(dashboard)/_authenticated/$companyId'
    | '/(dashboard)/_authenticated/'
    | '/(dashboard)/_authenticated/$companyId/actions'
    | '/(dashboard)/_authenticated/$companyId/forms'
    | '/(dashboard)/_authenticated/$companyId/mailbox'
    | '/(dashboard)/_authenticated/$companyId/my-mailbox'
    | '/(dashboard)/_authenticated/$companyId/settings'
    | '/(dashboard)/_authenticated/admin'
    | '/(dashboard)/_authenticated/admin/_guard'
    | '/(dashboard)/_authenticated/$companyId/'
    | '/(dashboard)/invitation/$invitationCode/'
    | '/(dashboard)/_authenticated/admin/_guard/companies'
    | '/(dashboard)/_authenticated/admin/_guard/users'
    | '/(dashboard)/_authenticated/admin/_guard/'
    | '/(dashboard)/_authenticated/$companyId/team/$teamId/actions'
    | '/(dashboard)/_authenticated/$companyId/team/$teamId/dashboard'
    | '/(dashboard)/_authenticated/$companyId/team/$teamId/forms'
    | '/(dashboard)/_authenticated/$companyId/f/$formId/'
    | '/(dashboard)/_authenticated/$companyId/team/$teamId/'
    | '/(dashboard)/_authenticated/$companyId/team/$teamId/f/$formId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authCodeRoute: typeof authCodeRoute
  authLoginRoute: typeof authLoginRoute
  dashboardRoute: typeof dashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(dashboard)': {
      id: '/(dashboard)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/_authenticated': {
      id: '/(dashboard)/_authenticated'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardAuthenticatedRouteImport
      parentRoute: typeof dashboardRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/code': {
      id: '/(auth)/code'
      path: '/code'
      fullPath: '/code'
      preLoaderRoute: typeof authCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/_authenticated/admin': {
      id: '/(dashboard)/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof dashboardAuthenticatedAdminRouteImport
      parentRoute: typeof dashboardAuthenticatedRoute
    }
    '/(dashboard)/_authenticated/': {
      id: '/(dashboard)/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardAuthenticatedIndexRouteImport
      parentRoute: typeof dashboardAuthenticatedRoute
    }
    '/(dashboard)/_authenticated/$companyId': {
      id: '/(dashboard)/_authenticated/$companyId'
      path: '/$companyId'
      fullPath: '/$companyId'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdRouteRouteImport
      parentRoute: typeof dashboardAuthenticatedRoute
    }
    '/(dashboard)/invitation/$invitationCode/': {
      id: '/(dashboard)/invitation/$invitationCode/'
      path: '/invitation/$invitationCode'
      fullPath: '/invitation/$invitationCode'
      preLoaderRoute: typeof dashboardInvitationInvitationCodeIndexRouteImport
      parentRoute: typeof dashboardRoute
    }
    '/(dashboard)/_authenticated/$companyId/': {
      id: '/(dashboard)/_authenticated/$companyId/'
      path: '/'
      fullPath: '/$companyId/'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdIndexRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/admin/_guard': {
      id: '/(dashboard)/_authenticated/admin/_guard'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof dashboardAuthenticatedAdminGuardRouteImport
      parentRoute: typeof dashboardAuthenticatedAdminRoute
    }
    '/(dashboard)/_authenticated/$companyId/settings': {
      id: '/(dashboard)/_authenticated/$companyId/settings'
      path: '/settings'
      fullPath: '/$companyId/settings'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdSettingsRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/$companyId/my-mailbox': {
      id: '/(dashboard)/_authenticated/$companyId/my-mailbox'
      path: '/my-mailbox'
      fullPath: '/$companyId/my-mailbox'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdMyMailboxRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/$companyId/mailbox': {
      id: '/(dashboard)/_authenticated/$companyId/mailbox'
      path: '/mailbox'
      fullPath: '/$companyId/mailbox'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdMailboxRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/$companyId/forms': {
      id: '/(dashboard)/_authenticated/$companyId/forms'
      path: '/forms'
      fullPath: '/$companyId/forms'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdFormsRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/$companyId/actions': {
      id: '/(dashboard)/_authenticated/$companyId/actions'
      path: '/actions'
      fullPath: '/$companyId/actions'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdActionsRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/admin/_guard/': {
      id: '/(dashboard)/_authenticated/admin/_guard/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof dashboardAuthenticatedAdminGuardIndexRouteImport
      parentRoute: typeof dashboardAuthenticatedAdminGuardRoute
    }
    '/(dashboard)/_authenticated/admin/_guard/users': {
      id: '/(dashboard)/_authenticated/admin/_guard/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof dashboardAuthenticatedAdminGuardUsersRouteImport
      parentRoute: typeof dashboardAuthenticatedAdminGuardRoute
    }
    '/(dashboard)/_authenticated/admin/_guard/companies': {
      id: '/(dashboard)/_authenticated/admin/_guard/companies'
      path: '/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof dashboardAuthenticatedAdminGuardCompaniesRouteImport
      parentRoute: typeof dashboardAuthenticatedAdminGuardRoute
    }
    '/(dashboard)/_authenticated/$companyId/team/$teamId/': {
      id: '/(dashboard)/_authenticated/$companyId/team/$teamId/'
      path: '/team/$teamId'
      fullPath: '/$companyId/team/$teamId'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdIndexRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/$companyId/f/$formId/': {
      id: '/(dashboard)/_authenticated/$companyId/f/$formId/'
      path: '/f/$formId'
      fullPath: '/$companyId/f/$formId'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdFFormIdIndexRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/$companyId/team/$teamId/forms': {
      id: '/(dashboard)/_authenticated/$companyId/team/$teamId/forms'
      path: '/team/$teamId/forms'
      fullPath: '/$companyId/team/$teamId/forms'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdFormsRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/$companyId/team/$teamId/dashboard': {
      id: '/(dashboard)/_authenticated/$companyId/team/$teamId/dashboard'
      path: '/team/$teamId/dashboard'
      fullPath: '/$companyId/team/$teamId/dashboard'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/$companyId/team/$teamId/actions': {
      id: '/(dashboard)/_authenticated/$companyId/team/$teamId/actions'
      path: '/team/$teamId/actions'
      fullPath: '/$companyId/team/$teamId/actions'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdActionsRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
    '/(dashboard)/_authenticated/$companyId/team/$teamId/f/$formId/': {
      id: '/(dashboard)/_authenticated/$companyId/team/$teamId/f/$formId/'
      path: '/team/$teamId/f/$formId'
      fullPath: '/$companyId/team/$teamId/f/$formId'
      preLoaderRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRouteImport
      parentRoute: typeof dashboardAuthenticatedCompanyIdRouteRoute
    }
  }
}

interface dashboardAuthenticatedCompanyIdRouteRouteChildren {
  dashboardAuthenticatedCompanyIdActionsRoute: typeof dashboardAuthenticatedCompanyIdActionsRoute
  dashboardAuthenticatedCompanyIdFormsRoute: typeof dashboardAuthenticatedCompanyIdFormsRoute
  dashboardAuthenticatedCompanyIdMailboxRoute: typeof dashboardAuthenticatedCompanyIdMailboxRoute
  dashboardAuthenticatedCompanyIdMyMailboxRoute: typeof dashboardAuthenticatedCompanyIdMyMailboxRoute
  dashboardAuthenticatedCompanyIdSettingsRoute: typeof dashboardAuthenticatedCompanyIdSettingsRoute
  dashboardAuthenticatedCompanyIdIndexRoute: typeof dashboardAuthenticatedCompanyIdIndexRoute
  dashboardAuthenticatedCompanyIdTeamTeamIdActionsRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdActionsRoute
  dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRoute
  dashboardAuthenticatedCompanyIdTeamTeamIdFormsRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdFormsRoute
  dashboardAuthenticatedCompanyIdFFormIdIndexRoute: typeof dashboardAuthenticatedCompanyIdFFormIdIndexRoute
  dashboardAuthenticatedCompanyIdTeamTeamIdIndexRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdIndexRoute
  dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRoute: typeof dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRoute
}

const dashboardAuthenticatedCompanyIdRouteRouteChildren: dashboardAuthenticatedCompanyIdRouteRouteChildren =
  {
    dashboardAuthenticatedCompanyIdActionsRoute:
      dashboardAuthenticatedCompanyIdActionsRoute,
    dashboardAuthenticatedCompanyIdFormsRoute:
      dashboardAuthenticatedCompanyIdFormsRoute,
    dashboardAuthenticatedCompanyIdMailboxRoute:
      dashboardAuthenticatedCompanyIdMailboxRoute,
    dashboardAuthenticatedCompanyIdMyMailboxRoute:
      dashboardAuthenticatedCompanyIdMyMailboxRoute,
    dashboardAuthenticatedCompanyIdSettingsRoute:
      dashboardAuthenticatedCompanyIdSettingsRoute,
    dashboardAuthenticatedCompanyIdIndexRoute:
      dashboardAuthenticatedCompanyIdIndexRoute,
    dashboardAuthenticatedCompanyIdTeamTeamIdActionsRoute:
      dashboardAuthenticatedCompanyIdTeamTeamIdActionsRoute,
    dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRoute:
      dashboardAuthenticatedCompanyIdTeamTeamIdDashboardRoute,
    dashboardAuthenticatedCompanyIdTeamTeamIdFormsRoute:
      dashboardAuthenticatedCompanyIdTeamTeamIdFormsRoute,
    dashboardAuthenticatedCompanyIdFFormIdIndexRoute:
      dashboardAuthenticatedCompanyIdFFormIdIndexRoute,
    dashboardAuthenticatedCompanyIdTeamTeamIdIndexRoute:
      dashboardAuthenticatedCompanyIdTeamTeamIdIndexRoute,
    dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRoute:
      dashboardAuthenticatedCompanyIdTeamTeamIdFFormIdIndexRoute,
  }

const dashboardAuthenticatedCompanyIdRouteRouteWithChildren =
  dashboardAuthenticatedCompanyIdRouteRoute._addFileChildren(
    dashboardAuthenticatedCompanyIdRouteRouteChildren,
  )

interface dashboardAuthenticatedAdminGuardRouteChildren {
  dashboardAuthenticatedAdminGuardCompaniesRoute: typeof dashboardAuthenticatedAdminGuardCompaniesRoute
  dashboardAuthenticatedAdminGuardUsersRoute: typeof dashboardAuthenticatedAdminGuardUsersRoute
  dashboardAuthenticatedAdminGuardIndexRoute: typeof dashboardAuthenticatedAdminGuardIndexRoute
}

const dashboardAuthenticatedAdminGuardRouteChildren: dashboardAuthenticatedAdminGuardRouteChildren =
  {
    dashboardAuthenticatedAdminGuardCompaniesRoute:
      dashboardAuthenticatedAdminGuardCompaniesRoute,
    dashboardAuthenticatedAdminGuardUsersRoute:
      dashboardAuthenticatedAdminGuardUsersRoute,
    dashboardAuthenticatedAdminGuardIndexRoute:
      dashboardAuthenticatedAdminGuardIndexRoute,
  }

const dashboardAuthenticatedAdminGuardRouteWithChildren =
  dashboardAuthenticatedAdminGuardRoute._addFileChildren(
    dashboardAuthenticatedAdminGuardRouteChildren,
  )

interface dashboardAuthenticatedAdminRouteChildren {
  dashboardAuthenticatedAdminGuardRoute: typeof dashboardAuthenticatedAdminGuardRouteWithChildren
}

const dashboardAuthenticatedAdminRouteChildren: dashboardAuthenticatedAdminRouteChildren =
  {
    dashboardAuthenticatedAdminGuardRoute:
      dashboardAuthenticatedAdminGuardRouteWithChildren,
  }

const dashboardAuthenticatedAdminRouteWithChildren =
  dashboardAuthenticatedAdminRoute._addFileChildren(
    dashboardAuthenticatedAdminRouteChildren,
  )

interface dashboardAuthenticatedRouteChildren {
  dashboardAuthenticatedCompanyIdRouteRoute: typeof dashboardAuthenticatedCompanyIdRouteRouteWithChildren
  dashboardAuthenticatedIndexRoute: typeof dashboardAuthenticatedIndexRoute
  dashboardAuthenticatedAdminRoute: typeof dashboardAuthenticatedAdminRouteWithChildren
}

const dashboardAuthenticatedRouteChildren: dashboardAuthenticatedRouteChildren =
  {
    dashboardAuthenticatedCompanyIdRouteRoute:
      dashboardAuthenticatedCompanyIdRouteRouteWithChildren,
    dashboardAuthenticatedIndexRoute: dashboardAuthenticatedIndexRoute,
    dashboardAuthenticatedAdminRoute:
      dashboardAuthenticatedAdminRouteWithChildren,
  }

const dashboardAuthenticatedRouteWithChildren =
  dashboardAuthenticatedRoute._addFileChildren(
    dashboardAuthenticatedRouteChildren,
  )

interface dashboardRouteChildren {
  dashboardAuthenticatedRoute: typeof dashboardAuthenticatedRouteWithChildren
  dashboardInvitationInvitationCodeIndexRoute: typeof dashboardInvitationInvitationCodeIndexRoute
}

const dashboardRouteChildren: dashboardRouteChildren = {
  dashboardAuthenticatedRoute: dashboardAuthenticatedRouteWithChildren,
  dashboardInvitationInvitationCodeIndexRoute:
    dashboardInvitationInvitationCodeIndexRoute,
}

const dashboardRouteWithChildren = dashboardRoute._addFileChildren(
  dashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  authCodeRoute: authCodeRoute,
  authLoginRoute: authLoginRoute,
  dashboardRoute: dashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
